export default __webpack_public_path__ + "static/ky-ef8e18776eff1caf6b648c5c29847b64.svg";